import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { containerVariants, itemVariants, textVariants } from '../../script/animation';
import { Link } from 'react-router';
import { sektorlerData } from '../../data/sektorler-data';

const Section3 = () => {
  const { t, i18n } = useTranslation();

  // Seçili dili al
  const currentLanguage = i18n.language;

  return (
    <div className="w-full bg-red grid grid-cols-11 relative bg-genesisBlue">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        className="col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 py-20"
      >

        <div className="text-white">
          <motion.h1 variants={textVariants} className="text-56 font-extrabold nunito-sans mb-10">
            {t('sectors_title')}
          </motion.h1>
        </div>


        <div className="col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 grid grid-cols-1 md:grid-cols-2 content-end md:gap-10 lg:gap-x-20 gap-y-10 lg:gap-y-8">
          {sektorlerData.map((sector, index) => (
            <Link >
              <motion.div variants={itemVariants} className="hover:scale-105 duration-300">
                <div className="space-y-10">
                  <div className="flex flex-col">
                    <h2 className="text-customGold text-30 font-bold mb-3">
                      {sector.name[currentLanguage]}
                    </h2>
                    <p className="text-white text-18">
                      {sector.description[currentLanguage]}
                    </p>
                  </div>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Section3;
